import {
  buyWithInstacredLandingRoute,
  bicRevampCategoryViewAllPage,
  offersInstacred,
  loginRoute,
  buyWithInstacredLandingPageSymlinkRoute,
  transactionHistoryRoute,
} from '../alias/homeRoutes';
import { isMobile } from '../utils/helper';

export const navMenuList = [
  buyWithInstacredLandingRoute.path,
  bicRevampCategoryViewAllPage.path,
  offersInstacred.path,
  loginRoute.path,
  isMobile && transactionHistoryRoute.path,
  buyWithInstacredLandingPageSymlinkRoute.path,
];



// WEBPACK FOOTER //
// ./constants/navMenuList.js